import React, { useEffect } from 'react'
import { Router, Switch } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core/styles'
import './index.css'
import { createBrowserHistory } from 'history'
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import { isMobile } from 'react-device-detect'
import theme from './theme'
import GlobalStyles from './components/GlobalStyles'
import DashboardLayout from './layouts'
import {
  RouteWrapper,
  ProtectedRouteWrapper,
  MoveBackHomeAfterLoggedInRouteWrapper,
} from './components/RouteWrapper'
import PortfolioPage from './pages/PortfolioPage'
import PortfolioPageMobile from './pages/PortfolioPageMobile'
import LoginPage from './pages/LoginPage'
import LoginPageMobile from './pages/LoginPageMobile'
import { Provider as PortfolioProvider } from './contexts/portfolio'
import { Provider as LoginProvider } from './contexts/login'
import CompanyPage from './pages/CompanyPage'
import CompanyPageMobile from './pages/CompanyPageMobile'

export const history = createBrowserHistory()

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <ReactNotification />
      <LoginProvider>
        <PortfolioProvider>
          <Router history={history}>
            <Switch>
              <ProtectedRouteWrapper
                path="/company"
                component={isMobile ? CompanyPageMobile : CompanyPage}
                layout={DashboardLayout}
              />
              <ProtectedRouteWrapper
                path="/portfolio"
                component={isMobile ? PortfolioPageMobile : PortfolioPage}
                layout={DashboardLayout}
              />
              <ProtectedRouteWrapper
                path="/portfolio/home"
                component={isMobile ? PortfolioPageMobile : PortfolioPage}
                layout={DashboardLayout}
              />
              <ProtectedRouteWrapper
                path="/portfolio/lastweek"
                component={isMobile ? PortfolioPageMobile : PortfolioPage}
                layout={DashboardLayout}
              />
              <ProtectedRouteWrapper
                exact
                path="/"
                component={isMobile ? PortfolioPageMobile : PortfolioPage}
                layout={DashboardLayout}
              />
              <MoveBackHomeAfterLoggedInRouteWrapper
                exact
                path="/login"
                component={isMobile ? LoginPageMobile : LoginPage}
                layout={(props: any) => <>{props.children}</>}
              />
            </Switch>
          </Router>
        </PortfolioProvider>
      </LoginProvider>
    </ThemeProvider>
  )
}

export default App
